import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { StickyNote } from "lucide-react";

/** Live warning banner: "Toplantı Notlarında X Adet Not İşlem Bekliyor".
 *  Shown on R&D, Sales Orders, Purchasing pages. Renders NOTHING when count = 0.
 *  Click → /meetings?department=<dept>&status=IN_PROGRESS
 */
export default function MeetingsBanner({ department, testid }) {
  const [count, setCount] = useState(0);
  const nav = useNavigate();
  const load = useCallback(async () => {
    try {
      const r = await api.get(`/meetings/pending-count?department=${encodeURIComponent(department)}`);
      setCount(r?.count || 0);
    } catch (_) { /* silent */ }
  }, [department]);
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [load]);
  if (!count || count <= 0) return null;
  return (
    <button
      type="button"
      data-testid={testid || `meetings-banner-${department}`}
      onClick={() => nav(`/meetings?department=${department}&status=IN_PROGRESS`)}
      className="mb-4 w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-amber-300 bg-amber-50 hover:bg-amber-100 text-amber-900 text-left transition"
    >
      <StickyNote size={18} className="shrink-0 text-amber-700" />
      <span className="text-sm font-semibold">
        Toplantı Notlarında <span className="text-amber-800">{count}</span> adet not işlem bekliyor
      </span>
      <span className="ml-auto text-xs opacity-70">Tıkla → Toplantı Notları</span>
    </button>
  );
}
